import type { NRecords } from '@app/types';
import type { NEmployees } from '@app/types/Employees';

export const hasRecordsOnDate = (
  employeeId: number,
  date: string,
  initialRecords: NRecords.ModelRecordsOnDates[]
) => {
  const recordsOnDates =
    Object(initialRecords).find(
      ({ EmployeeId }: { EmployeeId: NEmployees.Employee['Id'] }) =>
        EmployeeId === employeeId
    )?.RecordsOnDates || [];
  let recordsOnSpecificDate = null;

  for (const [key, value] of Object.entries(recordsOnDates)) {
    if (key.includes(date) && Number(value) > 0) {
      recordsOnSpecificDate = Number(value);
    }
  }

  return recordsOnSpecificDate;
};
